var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{class:_vm.previewClass,attrs:{"src":_vm.previewData.preview_path,"frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }